import actionTypes from "./actionTypes";
import * as loginUtils from "../utils/loginUtils";

// LOGIN
const loginRequest = () => ({
  type: actionTypes.LOGIN_REQUEST,
});
const loginSuccess = (res) => ({
  type: actionTypes.LOGIN_SUCCESS,
  res,
});
const loginFailure = (error) => ({
  type: actionTypes.LOGIN_FAILURE,
  error,
});
export const login = (username, password) => {
  return async (dispatch) => {
    try {
      dispatch(loginRequest());
      let user = await loginUtils.login(username, password);
      dispatch(loginSuccess(user));
    } catch (error) {
      dispatch(loginFailure(error));
    }
  };
};

// SIGN OUT
export const signOut = () => ({
  type: actionTypes.SIGN_OUT,
});

// REFRESH USER
const refreshUserRequest = () => ({
  type: actionTypes.REFRESH_USER_REQUEST,
});
const refreshUserSuccess = (res) => ({
  type: actionTypes.REFRESH_USER_SUCCESS,
  res,
});
const refreshUserFailure = (error) => ({
  type: actionTypes.REFRESH_USER_FAILURE,
  error,
});
export const refreshUser = () => {
  return async (dispatch) => {
    try {
      dispatch(refreshUserRequest());
      let isRefreshed = await loginUtils.refreshUser();
      dispatch(refreshUserSuccess(isRefreshed));
    } catch (error) {
      dispatch(refreshUserFailure(error));
    }
  };
};

// FORGOT PASSWORD
const forgotPasswordRequest = () => ({
  type: actionTypes.FORGOT_PASSWORD_REQUEST,
});
const forgotPasswordSuccess = (res) => ({
  type: actionTypes.FORGOT_PASSWORD_SUCCESS,
  res,
});
const forgotPasswordFailure = (error) => ({
  type: actionTypes.FORGOT_PASSWORD_FAILURE,
  error,
});
export const forgotPassword = (email) => {
  return async (dispatch) => {
    try {
      dispatch(forgotPasswordRequest());
      let res = await loginUtils.forgotPassword(email);
      dispatch(forgotPasswordSuccess(res));
    } catch (error) {
      dispatch(forgotPasswordFailure(error));
    }
  };
};

// change password
const changePasswordRequest = () => ({
  type: actionTypes.CHANGE_PASSWORD_REQUEST,
});
const changePasswordSuccess = (res) => ({
  type: actionTypes.CHANGE_PASSWORD_SUCCESS,
  res,
});
const changePasswordFailure = (error) => ({
  type: actionTypes.CHANGE_PASSWORD_FAILURE,
  error,
});
export const changePassword = (data) => {
  return async (dispatch) => {
    try {
      dispatch(changePasswordRequest());
      let res = await loginUtils.changePassword(data);
      dispatch(changePasswordSuccess(res));
    } catch (error) {
      dispatch(changePasswordFailure(error));
    }
  };
};

export const refreshToken = () => {
  return async (dispatch) => {
    try {
      dispatch(loginRequest());
      let user = await loginUtils.refreshToken();
      dispatch(loginSuccess(user));
    } catch (error) {
      dispatch(loginFailure(error));
    }
  };
};
